<template>
  <div class="layout__position-left layout__width-100">

    <el-form
      :model="searchParams"
      status-icon
      :rules="{}"
      ref="searchParams"
    >

      <div class="layout__padding-clear text__align-center layout__width-100">
        <div class="layout__search-field__insights-250px">
          <p class="layout__margin__bottom-10 text__align-left">Month Range</p>
          <el-form-item prop="salesDateRange">
            <el-date-picker
              v-model="searchParams.salesDateRange"
              type="monthrange"
              align="left"
              start-placeholder="Start Month"
              end-placeholder="End Month"
              :picker-options="pickerOptions"
              format="MM/yyyy"
              value-format="MM/yyyy"
            >
            </el-date-picker>
          </el-form-item>
        </div>

        <div class="layout__search-field__insights-250px">
          <p class="layout__margin__bottom-10 text__align-left">Filter</p>
          <el-form-item prop="salesInvoiced">
            <el-select
              v-model="invoicedValue"
              placeholder="Filter"
              @change="swapInvoiced"
            >
              <el-option
                v-for="component in invoicedArray"
                :key="component.value"
                :label="component.label"
                :value="component.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>

    </el-form>

    <el-button
      class="button-red button__base button__insights"
      v-on:click="getSales('searchParams')"
    >
      Refresh Data
    </el-button>

    <el-button
      class="button-teal button__base button__insights"
      :disabled="this.sales.length === 0"
      v-on:click="csv()"
    >
      Download CSV
    </el-button>

  </div>

</template>

<script>

import Axios from 'axios';
import moment from 'moment';
import download from 'downloadjs';
import { axios } from '@/mixins/Axios.js';
import { csvDownloadHelper } from '@/mixins/CsvDownloadHelper.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import directMailrRevenue from '../../enums/DirectMailrRevenue';

export default {
  name: 'directMailSpendSearch',
  mixins: [axios, csvDownloadHelper, dataFormatter],
  props: {
    searchParams: {},
    sales: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
      exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
      invoicedValue: 'A',
      directMailrRevenue: directMailrRevenue,
      invoicedArray: [
        {
          value: 'A',
          label: 'All',
        },
        {
          value: 'I',
          label: 'Invoiced',
        },
        {
          value: 'N',
          label: 'Not Invoiced',
        },
      ],
      downloadUrl: '',
      myChart: Object,
      pickerOptions: {
        shortcuts: [{
          text: 'This month',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          }
        }, {
          text: 'This year',
          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last 6 months',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  created() {
    console.log('CREATED');
    const date = new Date();
    date.setDate(date.getDate() - 7);
    console.log('created date');

    this.searchParams.salesDateRange[0] = moment().format('MM/YYYY');
    this.searchParams.salesDateRange[1] = moment().format('MM/YYYY');

    console.log(this.searchParams);
  },
  mounted() {
    console.log('MOUNTED');
    this.getSales('searchParams');
  },
  destroyed() {
    console.log('DESTROYED');
    this.searchParams.salesDateRange[0] = moment().format('MM/YYYY');
    this.searchParams.salesDateRange[1] = moment().format('MM/YYYY');

    console.log(this.searchParams);
  },
  beforeUpdate() {
    window.sessionStorage.setItem('_search', JSON.stringify(this.searchParams));
  },
  methods: {
    swapInvoiced: function (component) {
      console.log('dropdownValue=' + this.invoicedValue);
      // this.currentComponent = component;
    },
    getSales(searchParams) {

      this.$refs[searchParams].validate((valid) => {
        if (valid) {

          console.log('before');
          console.log(this.searchParams);

          let searchTerms = Object.assign({}, this.searchParams);
          console.log('searchTerms');
          console.log(searchTerms);

          console.log('after search is copied');
          console.log(this.searchParams);

          console.log('after search is copied - new object');
          console.log(searchTerms);

          var startDateArray = searchTerms.salesDateRange[0].split('/'),
            startDate = moment(new Date(startDateArray[1], startDateArray[0] - 1, 1)).format('YYYY%2FMM%2FDD'),
            endDateArray = searchTerms.salesDateRange[1].split('/'),
            endDate = moment(new Date(endDateArray[1], endDateArray[0], 0)).format('YYYY%2FMM%2FDD'),
            endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetDirectMailrRevenue?startDate=' +
              startDate + '&endDate=' + endDate + '&reportLevel=' + this.invoicedValue;

          console.log(endpoint);

          this.$parent.loading = true;

          Axios.get(endpoint, this.returnHeaderUsingToken())
            .then(response => {
              var lookup = {},
                result = [],
                dates = [],
                custNo = 0,
                orderDate,
                orders = response.data.directMailrRevenue;

              orders = orders.map((order) => {
                return {
                  ...order,
                  billperiod: `${order.billmonth}/${order.billyear}`,
                };
              });

              this.$parent.sales = orders;

              this.$nextTick(() => { // Loading should be closed asynchronously
                this.$parent.loading = false;
              });
            })
            .catch(error => {
              if (error.response) {
                this.$message.error('Sorry there has been an issue retrieving the information you requested.');
              }

              this.$nextTick(() => { // Loading should be closed asynchronously
                this.$parent.loading = false;
              });

              this.$parent.sales = [];
            });
        } else {
          return false;
        }
      });
    },
    csv() {
      const fields = this.directMailrRevenue.createLabelValueList();

      this.downloadCsv(this.exportDate, fields, this.sales);
    }
  }
};
</script>